import { Box, Flex, Text, Textarea, Tooltip } from "@chakra-ui/react";
import { Typography } from "@reconvert/react-ui-component";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import FieldError from "../FieldError";

interface MultiLineTextSelectorProps {
  titleText: string;
  value: string;
  setTitleValue: (data: { value: string }) => void;
  showToolTip?: boolean;
  toolTipText?: string;
  fieldError?: string;
}

const TooltipWrapper = ({ children, label, showToolTip = false }: { children: React.ReactNode, label: string, showToolTip?: boolean }) => {
  if (showToolTip) {

    return (
      <Tooltip label={label} fontSize="xs" placement="top" hasArrow>
        {children}
      </Tooltip>
    );
  }

  return (
    <>
      {children}
    </>
  );
};

const MultiLineTextSelector = ({ titleText, value, setTitleValue, showToolTip=false, toolTipText="", fieldError="" }: MultiLineTextSelectorProps) => {
  const { t } = useTranslation();
  const [hasBeenTouched, setHasBeenTouched] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const handleFocus = () => {
    setHasBeenTouched(true);
  };

  const handleChange = (e: any) => {
    const newValue = e.target.value;

    setTitleValue({ value: newValue });
    
    if (hasBeenTouched && !newValue.trim()) {
      setErrorMessage(t("This field is required"));
    } else {
      setErrorMessage("");
    }
  };

  const handleBlur = (e: any) => {
    const trimmedValue = e.target.value?.trim();

    setTitleValue({ value: trimmedValue });
    
    if (hasBeenTouched && !trimmedValue) {
      setErrorMessage(t("This field is required"));
    } else {
      setErrorMessage("");
    }
  };

  return (
    <Box mt={2}>
      <TooltipWrapper label={toolTipText} showToolTip={showToolTip}>
      <Flex gap={1} flexDirection={"column"}>
          <Typography color={"#6A7381"} width={"max-content"} bg={"var(--Natural-100, #F9FAFC)"} variant="small">
            {t(titleText)}
          </Typography>
          <Textarea 
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
            isInvalid={!!errorMessage || !!fieldError}
          />
          {fieldError && <FieldError error={fieldError} />}
        </Flex>
      </TooltipWrapper>
    </Box>
  );
};

export default MultiLineTextSelector;
